<template>
  <div v-if="!id">
    <AlertPop/>
  </div>
  <div class="limiter" v-if="id">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="image">
          <img :src="smartImage" alt="Smart Image">
        </div>
        <form class="login100-form validate-form" @submit.prevent="handleSubmit">
          <div class="progress-container">
            <div class="step-indicator">
              <div :class="['step', { active: currentStep === 1 }]"></div>
              <div :class="['step', { active: currentStep === 2 }]"></div>
              <div :class="['step', { active: currentStep === 3 }]"></div>
              <div :class="['step', { active: currentStep === 4 }]"></div>
              <div :class="['step', { active: currentStep === 5 }]"></div>
              <div :class="['step', { active: currentStep === 6 }]"></div>
            </div>
          </div>
          <span class="login100-form-title">
            {{ stepTitle }}
          </span>

          <!-- Step 1: Company Info -->
          <div v-if="currentStep === 1">
            <div class="form-group">
              <label for="storeName">Store Name</label>
              <input id="storeName" class="input100" type="text" name="storeName" placeholder="Enter Store Name" v-model="storeName">
            </div>
            <div class="form-group">
              <label for="tpin">TPIN</label>
              <input id="tpin" class="input100" type="text" name="tpin" placeholder="Enter TPIN" v-model="tpin">
            </div>
            <div class="form-group">
              <label for="physicalAddress">Physical Address</label>
              <input id="physicalAddress" class="input100" type="text" name="physicalAddress" placeholder="Enter Physical Address" v-model="physicalAddress">
            </div>
            <div class="form-group">
              <label for="telephone">Telephone</label>
              <input id="telephone" class="input100" type="text" name="telephone" placeholder="Enter Telephone Number" v-model="telephone">
            </div>

            <div class="form-group">
              <label for="selectedArea">Area</label>
              <select id="selectedArea" class="input100" name="selectedArea" v-model="selectedArea">
                <option value="" disabled>Select Area</option>
                <option value="Lusaka">Lusaka</option>
                <option value="Copperbelt">Copperbelt</option>
                <option value="Outside">Other</option>
              </select>
            </div>


            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="nextStep">
                Next
              </button>
            </div>
          </div>

          <!-- Step 2: Additional Company Info -->
          <div v-if="currentStep === 2">

            <!-- Show additional input if "Outside" is selected -->
            <div v-if="selectedArea === 'Outside'" class="form-group">
              <label for="selectedlocation">Enter Area</label>
              <input id="selectedlocation" class="input100" type="text" name="selectedlocation" placeholder="Enter Area" v-model="selectedArea">
            </div>

            <div class="form-group">
              <label for="businessType">Business Type</label>
              <select id="businessType" class="input100" name="businessType" v-model="businessType">
                <option disabled value="">Select Business Type</option>
                <option value="Wholesale">Wholesale</option>
                <option value="Restaurant">Restaurant</option>
                <option value="Bar">Bar</option>
                <option value="Takeaway">Takeaway</option>
                <option value="Butchery">Butchery</option>
                <option value="Business to Business">Business to Business</option>
              </select>
            </div>
            <div class="form-group">
              <label for="companyEmail">Email</label>
              <input id="companyEmail" class="input100" type="email" name="companyEmail" placeholder="Enter Email" v-model="companyEmail">
            </div>
            <div class="form-group">
              <label for="branchName">Branch Name</label>
              <input id="branchName" class="input100" type="text" name="branchName" placeholder="Enter Branch Name" v-model="branchName">
            </div>
            <div class="form-group">
              <label for="location">Add Location</label>
              <input id="location" class="input100" type="text" name="location" placeholder="Paste Your Location" v-model="location">
              <div class="location-buttons">
                <button type="button" class="btn-location" @click="openMap">Click to Get Location</button>
                <button type="button" class="btn-location" @click="showInstructions">How to Get Location</button>
              </div>
            </div>
            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="prevStep">
                Previous
              </button>
              <button type="button" class="login100-form-btn" @click="nextStep">
                Next
              </button>
            </div>
          </div>

          <!-- Step 3: Representative Info -->
          <div v-if="currentStep === 3">
            <div class="form-group">
              <label for="ownerName">Name</label>
              <input id="ownerName" class="input100" type="text" name="ownerName" placeholder="Enter Your Name" v-model="ownerName">
            </div>
            <div class="form-group">
              <label for="position">Position</label>
              <input id="position" class="input100" type="text" name="position" placeholder="Enter Position" v-model="position">
            </div>
            <div class="form-group">
              <label for="ownerAddress">Address</label>
              <input id="ownerAddress" class="input100" type="text" name="ownerAddress" placeholder="Enter Address" v-model="ownerAddress">
            </div>
            <div class="form-group">
              <label for="ownerTelephone">Telephone</label>
              <input id="ownerTelephone" class="input100" type="text" name="ownerTelephone" placeholder="Enter Telephone Number" v-model="ownerTelephone">
            </div>
            <div class="form-group">
              <label for="ownerEmail">Email</label>
              <input id="ownerEmail" class="input100" type="email" name="ownerEmail" placeholder="Enter Email" v-model="ownerEmail">
            </div>
            <div class="form-group">
              <label for="nrcNumber">NRC or PASSPORT</label>
              <input id="nrcNumber" class="input100" type="email" name="nrcNumber" placeholder="Enter NRCorPassPort Number" v-model="nrcNumber">
            </div>

            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="prevStep">
                Previous
              </button>
              <button type="button" class="login100-form-btn" @click="nextStep">
                Next
              </button>
            </div>
          </div>

          <!-- Step 4: Representative Documentation -->
          <div v-if="currentStep === 4">
            <div class="form-group file-input-container">
              <input
                  id="file-nrcPassport"
                  class="input100"
                  type="file"
                  name="nrcPassport"
                  @change="handleFileChange($event, 'nrcPassport')"
                  accept=".pdf,image/*"
              >
              <label for="file-nrcPassport" class="btn-file-input">{{ nrcPassportFileName || 'Choose NRC/Passport' }}</label>
            </div>
            <div class="form-group file-input-container">
              <input
                  id="file-tpinCert"
                  class="input100"
                  type="file"
                  name="tpinCert"
                  @change="handleFileChange($event, 'tpinCert')"
                  accept=".pdf,image/*"
              >
              <label for="file-tpinCert" class="btn-file-input">{{ tpinCertFileName || 'Choose TIN Certificate' }}</label>
            </div>
            <div class="form-group file-input-container">
              <input
                  id="file-pacraCert"
                  class="input100"
                  type="file"
                  name="pacraCert"
                  @change="handleFileChange($event, 'pacraCert')"
                  accept=".pdf,image/*"
              >
              <label for="file-pacraCert" class="btn-file-input">{{ pacraCertFileName || 'Choose PACRA Certificate' }}</label>
            </div>
            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="prevStep">
                Previous
              </button>
              <button type="button" class="login100-form-btn" @click="nextStep">
                Next
              </button>
            </div>
          </div>


          <!-- Step 5: Summary -->
          <div v-if="currentStep === 5">
            <div class="form-summary">
              <h2 style="color: red">Company Info</h2>
              <div class="form-group">
                <p class="summary-item"><strong>Store Name:</strong> {{ storeName }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>TPIN:</strong> {{ tpin }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Physical Address:</strong> {{ physicalAddress }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Telephone:</strong> {{ telephone }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Area:</strong> {{ selectedArea }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Email:</strong> {{ companyEmail }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Branch Name:</strong> {{ branchName }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Add Location:</strong> {{ location }}</p>
              </div>
              <h2 style="color: red">Representative Info</h2>
              <div class="form-group">
                <p class="summary-item"><strong>Name:</strong> {{ ownerName }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Position:</strong> {{ position }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Address:</strong> {{ ownerAddress }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Telephone:</strong> {{ ownerTelephone }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>Email:</strong> {{ ownerEmail }}</p>
              </div>
              <div class="form-group">
                <p class="summary-item"><strong>NRC or PASSPORT:</strong> {{ nrcNumber }}</p>
              </div>

            </div>
            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="prevStep">
                Previous
              </button>
              <button type="button" class="login100-form-btn" @click="nextStep">
                Next
              </button>
            </div>
          </div>

          <!-- Step 6: Signature -->
          <div v-if="currentStep === 6">
            <VueSignature @signature-saved="handleSignatureSaved"/>
            <div class="form-navigation">
              <button type="button" class="login100-form-btn" @click="prevStep">
                Previous
              </button>
              <button
                  type="button"
                  class="login100-form-btn"
                  @click="handleSubmit"
                  v-if="signatureSaved"
              >
                Submit
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import VueSignature from '@/components/VueSignature';
import AlertPop from '@/components/AlertPop';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useStore } from 'vuex';
import Loader from "@/components/Loader";

export default {
  name: 'LoginForm',
  components: {
    Loader,
    VueSignature,
    AlertPop
  },

  setup() {
    const store = useStore();
    const route = useRoute();
    const id = ref(null);
    const currentStep = ref(1);
    const stepTitle = ref('Company Info');
    const signaturePad = ref(null);
    const signatureSaved = ref(false);
    const signatureData = ref(null);

    // Fetch the id from route query on mount
    onMounted(() => {
      id.value = route.query.id;
    });

    // Watch for changes in the route query to update the id
    watch(() => route.query.id, (newId) => {
      id.value = newId;
    });

    const smartImage = require('@/assets/smart.png');
    const storeName = ref('');
    const tpin = ref('');
    const physicalAddress = ref('');
    const companyEmail = ref('');
    const telephone = ref('');
    const selectedArea = ref('');
    const selectedlocation = ref('');

    const branchName = ref('');
    const location = ref('');
    const nrcPassportFileType = ref('');
    const tpinCertFileType = ref('');
    const pacraCertFileType = ref('');

    const ownerName = ref('');
    const position = ref('');
    const ownerAddress = ref('');
    const ownerTelephone = ref('');
    const ownerEmail = ref('');

    const tpinCert = ref('');
    const nrcPassport = ref('');
    const pacraCert = ref('');

    const nrcPassportFileName = ref('');
    const tpinCertFileName = ref('');
    const pacraCertFileName = ref('');
    const businessType = ref('');
    const nrcNumber = ref('')

    const handleFileChange = async (event, field) => {
      const file = event.target.files[0];
      if (file) {
        const base64 = await getBase64(file);
        const fileType = file.type; // Get the file type
        switch (field) {
          case 'nrcPassport':
            nrcPassport.value = base64;
            nrcPassportFileName.value = file.name;
            nrcPassportFileType.value = fileType; // Store the file type
            break;
          case 'tpinCert':
            tpinCert.value = base64;
            tpinCertFileName.value = file.name;
            tpinCertFileType.value = fileType; // Store the file type
            break;
          case 'pacraCert':
            pacraCert.value = base64;
            pacraCertFileName.value = file.name;
            pacraCertFileType.value = fileType; // Store the file type
            break;
        }
      }
    };


    const handleSignatureSaved = (data) => {
      console.log("Signature Saved:", data);
      signatureSaved.value = data; // Update the signatureSaved state
    };


    const getBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    };

    const handleSubmit = async () => {
      Swal.fire({
        title: 'Loading...',
        html: '<div class="swal-spinner"></div>',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      console.log(signatureSaved.value)
      // Get the signature data from the VueSignature component
      const handleSubmit = async () => {
        console.log("Current Signature Data:", signatureSaved.value);
        // Proceed with the submission logic
      };

      console.log(signatureSaved.value);

      // Prepare the data in the required format
      const payload = {
        invoiceNumber: id.value, // Or use a dynamic value if applicable
        companyInfo: {
          name: storeName.value,
          businessType: businessType.value,
          storeLocation: location.value,
          storeReference: branchName.value,
          tpinNumber: tpin.value,
          tpinCertificate: tpinCert.value,
          tpinDocumentType: tpinCertFileType.value, // Assuming document type is fixed
          physicalAddress: physicalAddress.value,
          email: companyEmail.value,
          telephoneNumber: telephone.value,
          pacraCertificate: pacraCert.value,
          pacraDocumentType: pacraCertFileType.value, // Assuming document type is fixed
          storeArea: selectedArea.value // Use the selected area value
        },
        businessInfo: {
          name: ownerName.value,
          position: position.value,
          postalAddress: ownerAddress.value,
          telephoneNumber: ownerTelephone.value,
          email: ownerEmail.value,
          nrcOrPassportNo: nrcNumber.value,
          nrcOrPassport: nrcPassport.value, // Use file name or other relevant value
          nrcOrPassportDocumentType: nrcPassportFileType.value , // Assuming document type is fixed
          signature: signatureSaved.value,
        }
      };
      console.log({payload})
      try {
        console.log("am reaching");


        await axios.post(synergyApi+'store-registration/save-store', payload);
        Swal.close()

        return Swal.fire({
          title: 'Success',
          text: 'Your information has been submitted!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then(() => window.close());

      } catch (error) {
        Swal.close()

        console.error('Submission error:', error);
        return errorHandler.tomcatError(error);
        // Swal.fire({
        //   icon: 'error',
        //   title: 'Oops...',
        //   text: error,
        // });
        // Swal.fire('Error', 'An error occurred during submission. Please try again.', 'error');
      }
    };

    const openMap = () => {
      if (storeName.value) {
        const query = encodeURIComponent(storeName.value);
        const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
        window.open(url, '_blank');
      } else {
        const url = `https://www.google.com/maps/`;
        window.open(url);
      }
    };

    const images = [
      { src: require('@/assets/s1.jpg'), instructions: '1. Click on the get location button.' },
      { src: require('@/assets/s2.jpg'), instructions: '2. CLick the share button.' },
      { src: require('@/assets/s5.jpg'), instructions: '2. Copy the address or coordinates.' },
      { src: require('@/assets/s3.jpg'), instructions: '3. Paste them into the location field.' },
      { src: require('@/assets/s4.jpg'), instructions: '4. Click next.' }

    ];

    const showInstructions = () => {
      Swal.fire({
        title: 'How to Get Your Location',
        html: `
      <div class="slideshow-container">
        ${images.map((image, index) => `
          <div class="slide ${index === 0 ? 'active' : ''}">
            <img src="${image.src}" alt="Slide ${index + 1}">
          </div>
        `).join('')}
        <button class="prev" id="prev" onclick="changeSlide(-1)">&#10094;</button>
        <button class="next" id="next" onclick="changeSlide(1)">&#10095;</button>
        <button class="close" id="close">X</button>
      </div>
      <style>
        .swal2-title {
          font-size: 18px; /* Reduce title font size */
          font-weight: bold;
          text-align: center;
          margin: 0;
        }
        .slideshow-container {
          position: relative;
          max-width: 100%;
          margin: auto;
          border: 2px solid #ddd;
          border-radius: 10px;
          overflow: hidden;
          background-color: #f9f9f9;
        }
        .slide {
          position: relative;
          display: none;
        }
        .slide.active {
          display: block;
        }
        .slide img {
          width: 100%;
          height: 400px;

          object-fit: contain; /* Ensure the image covers the container */
        }
        .prev, .next {
          cursor: pointer;
          position: absolute;
          top: 50%;
          width: auto;
          padding: 16px;
          margin-top: -22px;
          color: white;
          font-weight: bold;
          font-size: 24px;
          transition: 0.6s ease;
          border-radius: 3px;
          background-color: rgba(0, 0, 0, 0.5);
          border: none;
        }
        .prev {
          left: 0;
          border-radius: 3px 0 0 3px;
        }
        .next {
          right: 0;
          border-radius: 0 3px 3px 0;
        }
        .prev:hover, .next:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
        .close {
          position: absolute;
          top: 10px;
          right: 10px;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          border: none;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          font-size: 20px;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
        }
        .close:hover {
          background: rgba(0, 0, 0, 0.9);
        }
      </style>
    `,
        showConfirmButton: false,
        allowOutsideClick: false, // Prevent closing by clicking outside
        allowEscapeKey: true, // Allow ESC key to close
        didOpen: () => {
          const slides = document.querySelectorAll('.slide');
          let currentIndex = 0;
          const totalSlides = slides.length;
          const prevButton = document.getElementById('prev');
          const nextButton = document.getElementById('next');
          const swalTitle = Swal.getTitle(); // Get the title element of Swal

          const updateTitle = () => {
            const instructions = images[currentIndex].instructions;
            swalTitle.textContent = instructions;
          };

          const updateButtons = () => {
            prevButton.classList.toggle('disabled', currentIndex === 0);
            nextButton.classList.toggle('disabled', currentIndex === totalSlides - 1);
          };

          const changeSlide = (n) => {
            if ((n < 0 && currentIndex === 0) || (n > 0 && currentIndex === totalSlides - 1)) return;
            slides[currentIndex].classList.remove('active');
            currentIndex += n;
            slides[currentIndex].classList.add('active');
            updateTitle();
            updateButtons();
          };

          updateTitle(); // Initialize title
          updateButtons(); // Initialize button state

          document.getElementById('close').addEventListener('click', () => Swal.close());
          window.changeSlide = changeSlide; // Expose function to global scope for buttons
        }
      });
    };

    const nextStep = () => {
      if (currentStep.value === 1 && validateStep1()) {
        currentStep.value = 2;
        stepTitle.value = 'Additional Company Info';
      } else if (currentStep.value === 2 && validateStep2()) {
        currentStep.value = 3;
        stepTitle.value = 'Representative Info';
      } else if (currentStep.value === 3 && validateStep3()) {
        currentStep.value = 4;
        stepTitle.value = 'Documentation';
      } else if (currentStep.value === 4 && validateStep4()) {
        currentStep.value = 5;
        stepTitle.value = 'Summary';
      } else if (currentStep.value === 5 && validateStep5()) {
        currentStep.value = 6;
        stepTitle.value = 'Signature';
      }
    };

    const prevStep = () => {
      if (currentStep.value === 6) {
        currentStep.value = 5;
        stepTitle.value = 'Summary';
      } else if (currentStep.value === 5) {
        currentStep.value = 4;
        stepTitle.value = 'Documentation';
      } else if (currentStep.value === 4) {
        currentStep.value = 3;
        stepTitle.value = 'Representative Info';
      } else if (currentStep.value === 3) {
        currentStep.value = 2;
        stepTitle.value = 'Additional Company Info';
      } else if (currentStep.value === 2) {
        currentStep.value = 1;
        stepTitle.value = 'Company Info';
      }
    };

    const isEmailValid = (email) => {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    };

    const validateStep1 = () => {
      return true;
    };

    const validateStep2 = () => {
      if (!isEmailValid(companyEmail.value)) {
        Swal.fire('Error', 'Please enter a valid company email address.', 'error');
        return false;
      }
      return true;
    };

    const validateStep3 = () => {
      if (!isEmailValid(ownerEmail.value)) {
        Swal.fire('Error', 'Please enter a valid representative email address.', 'error');
        return false;
      }
      return true;
    };

    const validateStep4 = () => {
      return true;
    };

    const validateStep5 = () =>{
      return true;
    };

    return {
      id,
      smartImage,
      storeName,
      selectedArea,
      tpin,
      signatureSaved,
      handleSignatureSaved,
      physicalAddress,
      companyEmail,
      telephone,
      branchName,
      location,
      ownerName,
      position,
      ownerAddress,
      ownerTelephone,
      ownerEmail,
      tpinCert,
      nrcPassport,
      pacraCert,
      nrcPassportFileName,
      tpinCertFileName,
      pacraCertFileName,
      handleFileChange,
      handleSubmit,
      openMap,
      showInstructions,
      signaturePad,
      currentStep,
      stepTitle,
      nextStep,
      prevStep,
      selectedlocation,
      businessType,
      nrcNumber,
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,600,700,800,900');
@import url('https://fonts.googleapis.com/css?family=Raleway:400,500,600,700,800');

body, html {
  height: 100%;
  font-family: Poppins-Regular, sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  background: #f2f2f2;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
}

p {
  margin: 0;
}

ul, li {
  margin: 0;
  list-style-type: none;
}

input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}

button {
  outline: none;
  border: none;
  background: transparent;
}

input:focus, textarea:focus, select:focus, button:focus {
  outline: none;
}

input::-webkit-input-placeholder { color: #999; }
input:-moz-placeholder { color: #999; }
input::-moz-placeholder { color: #999; }
input:-ms-input-placeholder { color: #999; }
textarea::-webkit-input-placeholder { color: #999; }
textarea:-moz-placeholder { color: #999; }
textarea::-moz-placeholder { color: #999; }
textarea:-ms-input-placeholder { color: #999; }

.limiter {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.container-login100 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.wrap-login100 {
  width: 100%;
  max-width: 600px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px; /* Adjust as needed */
}

.image img {
  max-width: 100%;
  height: auto;
  display: block;
}


/* Media Queries */
@media (max-width: 768px) {
  .image {
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .image {
    margin-bottom: 10px;
  }
}
.login100-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login100-form-title {
  font-size: 16px;
  color: #333;
  text-align: center;
  display: block;
  line-height: 1.2;
  margin-top: 10px;
  margin-bottom: 20px;
}

.input100 {
  width: 100%;
  min-width: 330px; /* Minimum width for select input */
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  font-size: 14px;
  box-sizing: border-box;
}

.input100:focus + .focus-input100 {
  -webkit-animation: anim-shadow 0.5s ease-in-out forwards;
  animation: anim-shadow 0.5s ease-in-out forwards;
}

.input100:focus + .focus-input100 + .symbol-input100 {
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(67, 183, 37, 0.5);
}

.file-input-container {
  position: relative;
}

input[type="file"] {
  display: none;
}
.btn-file-input {
  min-width: 250px; /* Minimum width for select input */
  display: block;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background: #fff;
  text-align: center;
}

.login100-form-btn {
  width: 48%;
  padding: 10px;
  border-radius: 5px;
  border: none;
  background: #007bff;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}
.login100-form-btn:hover {
  transform: scale(1.05);
}
select.input100 {
  /* Add these styles to make the select input look consistent */
  outline: none;
  color: #333;
  line-height: 1.2;
  width: 100%;
  box-sizing: border-box;
}

.form-group {
  margin-bottom: 15px;
  width: 100%;
}

.form-group label {
  font-family: Poppins-Medium;
  font-size: 15px;
  color: #333;
  display: block;
  margin-bottom: 5px;
}

.file-input-container {
  position: relative;
}

.file-input-container label {
  display: block;
  font-size: 14px;
  color: #333;
}

.file-input-container label {
  background: #e6e6e6;
  color: #666;
  padding: 10px 20px;
  cursor: pointer;
  transition: background 0.4s;
}

.file-input-container label:hover {
  background: #d4d4d4;
}

.form-navigation {
  display: flex;
  justify-content: space-between;
}

.form-navigation .login100-form-btn {
  margin: 0;
}

.btn-location {
  margin: 1rem;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: white;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
}

.btn-location:hover {
  transform: scale(1.05);
}

.instructions {
  position: absolute;
  top: 10px; /* Position above the image */
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  max-width: 90%;
}
.step-indicator {
  display: flex;
  justify-content: space-between; /* Adjust spacing */
  align-items: center;
}

.step {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ddd;
  margin: 0 10px; /* Adjust spacing as needed */
  transition: background-color 0.3s ease;
}

.step.active {
  background-color: #4caf50; /* Active step color */
}
.form-summary {
  display: block;
}

.form-group {
  flex: 1 1 calc(50% - 20px); /* Adjust width to fit 2 items per row minus the gap */
  box-sizing: border-box;
}

.summary-item {
  font-size: 16px; /* Adjust the font size as needed */
  color: #333; /* Set the text color */
  margin: 5px 0; /* Adjust margin for spacing */
}

.summary-item strong {
  font-weight: bold;
}

</style>


